<template>
  <v-form>
    <gg-input-label>RAW Record</gg-input-label>
    <v-textarea
      outlined
      dense
      name="RAW Record"
      rows="3"
      v-model="model.txtdata"></v-textarea>
    <gg-text-field
      label="Name"
      name="Name"
      placeholder="Valid zone name"
      disabled
      v-model="model.name"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="TTL"
      name="TTL"
      placeholder="14400"
      v-model="model.ttl"
      v-validate="rules.ttl"
      :error-messages="errors.collect('TTL')"
      @input="sendData"></gg-text-field>
    <label>Policy</label>
    <v-radio-group v-model="model_for_record.p" class="mt-1" row hide-details>
      <v-radio color="primary" label="None" value="none"></v-radio>
      <v-radio color="primary" label="Quarantine" value="quarantine"></v-radio>
      <v-radio color="primary" label="Reject" value="reject"></v-radio>
    </v-radio-group>
    <v-switch label="Optional parameters" color="primary" v-model="optional"></v-switch>
    <v-slide-y-transition>
      <div v-if="optional">
        <label>Subdomain policy</label>
        <v-radio-group v-model="model_for_record.sp" class="mt-1" row hide-details>
          <v-radio color="primary" label="None" value="none"></v-radio>
          <v-radio color="primary" label="Quarantine" value="quarantine"></v-radio>
          <v-radio color="primary" label="Reject" value="reject"></v-radio>
        </v-radio-group>
        <label>DKIM mode</label>
        <v-radio-group v-model="model_for_record.adkim" class="mt-1" row hide-details>
          <v-radio color="primary" label="Relaxed" value="r"></v-radio>
          <v-radio color="primary" label="Strict" value="s"></v-radio>
        </v-radio-group>
        <label>SPF mode</label>
        <v-radio-group v-model="model_for_record.aspf" class="mt-1" row hide-details>
          <v-radio color="primary" label="Relaxed" value="r"></v-radio>
          <v-radio color="primary" label="Strict" value="s"></v-radio>
        </v-radio-group>
        <gg-text-field
          label="Percentage"
          name="Percentage"
          type="number"
          min="0"
          max="100"
          v-model="model_for_record.pct"
          v-validate="rules.percentage"
          :error-messages="errors.collect('Percentage')"></gg-text-field>
        <label>Generate failure reports when</label>
        <v-radio-group v-model="model_for_record.fo" class="mt-1" row hide-details>
          <v-radio color="green" label="All checks fail" value="0"></v-radio>
          <v-radio color="green" label="Any check fails" value="1"></v-radio>
        </v-radio-group>
        <label>Report format</label>
        <v-radio-group v-model="model_for_record.rf" class="mt-1" row hide-details>
          <v-radio color="green" label="AFRF" value="afrf"></v-radio>
          <v-radio color="green" label="IODEF" value="iodef"></v-radio>
        </v-radio-group>
        <gg-text-field
          label="Report interval"
          name="Report interval"
          type="number"
          v-model="model_for_record.ri"
          v-validate="rules.interval"
          :error-messages="errors.collect('Report interval')"></gg-text-field>
        <gg-input-label>URI</gg-input-label>
        <v-textarea
          outlined
          dense
          name="URI"
          rows="1"
          class="gg-input"
          placeholder="Comma-delimited mailto URIs"
          hint="Send aggregate mail reports to"
          persistent-hint
          v-model="model_for_record.rua"
          v-validate="rules.rua"
          :error-messages="errors.collect('URI')"></v-textarea>
        <gg-input-label>URI</gg-input-label>
        <v-textarea
          outlined
          dense
          name="ruf"
          rows="1"
          class="gg-input"
          placeholder="Comma-delimited mailto URIs"
          hint="Send failure reports to"
          persistent-hint
          v-model="model_for_record.ruf"
          v-validate="rules.ruf"
          data-vv-as="URI"
          :error-messages="errors.collect('ruf')"></v-textarea>
      </div>
    </v-slide-y-transition>
  </v-form>
</template>

<script>
import { ZoneRecord } from '@/mixins/ZoneRecord'

export default {
  name: 'DMARKRecordForm',
  mixins: [ZoneRecord],
  inject: ['parentValidator'],
  props: {
    domain: {
      type: String
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: {
        name: '',
        ttl: '14400',
        txtdata: ''
      },
      model_for_record: {
        p: 'none',
        sp: 'none',
        adkim: 'r',
        aspf: 'r',
        pct: '100',
        fo: '0',
        rf: 'afrf',
        ri: '86400',
        rua: '',
        ruf: ''
      },
      rules: {
        ttl: { required: true, numeric: true },
        percentage: {
          required: true,
          numeric: true
        },
        interval: {
          required: true,
          numeric: true
        },
        rua: { regex: /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/ }
      },
      optional: false
    }
  },
  methods: {
    applyName () {
      this.model.name = `_dmarc.${this.domain}.`
    },
    parseToRaw () {
      let arr = []

      arr.push('v=DMARC1')

      for (let key in this.model_for_record) {
        if (this.model_for_record.hasOwnProperty(key)) {
          if (this.model_for_record[key] !== '') {
            arr.push(`${key}=${this.model_for_record[key]}`)
          }

          this.model.txtdata = arr.join(';')
        }
      }
      // Update model
      this.sendData()
    },
    fillEditData () {
      for (let key in this.item) {
        if (this.item.hasOwnProperty(key)) {
          this.model[key] = this.item[key]
        }
      }
    }
  },
  watch: {
    model_for_record: {
      handler: 'parseToRaw',
      deep: true
    },
    'model.txtdata': function () {
      let arr
      let newArr = []

      // Parse a string to array
      arr = this.model.txtdata.split(';')

      // Remove the first value (v=DMARC1)
      arr.splice(0, 1)

      // Splice array
      arr.forEach(item => {
        newArr.push(item.split('='))
      })

      // Update model
      newArr.forEach(item => {
        if (item[0] in this.model_for_record) {
          this.model_for_record[item[0]] = item[1]
        }
      })
    }
  },
  created () {
    this.$validator = this.parentValidator
    if (this.edit) {
      this.fillEditData()
    }
    this.applyName()
    this.parseToRaw()
    this.sendData()
  }
}
</script>
